module.exports = __webpack_public_path__ + "img/google.0fdf5559.svg";